<script lang="ts" setup>
import { MateWithChatInfo } from "@/types/chat";

withDefaults(
  defineProps<{
    showCount?: boolean;
  }>(),
  {
    showCount: true,
  }
);
</script>
<template>
  <div
    class="overflow-hidden rounded-lg cursor-pointer flex flex-col bg-base-200 relative border /80 w-full h-full"
  >
    <div class="relative rounded-lg overflow-hidden w-full h-full">
      <div class="h-full skeleton-loading-bg aspect-[3/4]" />
      <div
        class="flex flex-col flex-1 gap-2 absolute top-0 bottom-0 left-0 right-0 p-2 linear-background justify-between"
      >
        <div class="flex justify-between items-center"></div>
        <div class="flex flex-col gap-1 text-white">
          <div class="skeleton-loading-bg rounded h-4 w-[50%]" />
          <div class="skeleton-loading-bg rounded h-3 w-full" />
          <div class="skeleton-loading-bg rounded h-3 w-full" />
          <div class="skeleton-loading-bg rounded h-3 w-[80%]" />
        </div>
      </div>
    </div>
    <div class="flex py-1.5 gap-1 p-2">
      <div
        v-for="item in 3"
        :key="item"
        class="w-4 h-3 bg-neutral skeleton-loading-bg rounded"
      />
    </div>
  </div>
</template>
<style scoped>
.linear-background {
  background: linear-gradient(rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0.8) 85%);
}
</style>
